module.exports = __webpack_public_path__ + "img/Vector 41.c9cd66d1.png";